import { apiFetch } from "../utils/apiFetch";

export interface TrademarkSearchParams {
  trademark?: string;
  applicationNumber?: string;
  registrationNumber?: string; // legacy callers only; EUIPO does not index this field
  page?: number;
  size?: number;
  claimType?: "priority" | "seniority";
  referenceDate?: string;
  country?: string;
}
export interface EuipoTrademarkResult {
  markName: string;
  applicationNumber: string;
  registrationNumber?: string;
  applicationDate?: string;
  registrationDate?: string;
  status?: string;
  owner?: string;
  office: string;
  seniorities?: EuipoSeniority[];
}
export interface EuipoPriority {
  country?: string;
  applicationNumber?: string;
  applicationDate?: string;
  status?: string;
}
export interface EuipoSeniority {
  country?: string;
  applicationNumber?: string;
  applicationDate?: string;
  registrationNumber?: string;
  registrationDate?: string;
  status?: string;
}
export interface EuipoTrademarkDetails {
  applicationNumber: string;
  applicationDate?: string;
  registrationDate?: string;
  status?: string;
  wordMarkSpecification?: { verbalElement?: string };
  priorities?: EuipoPriority[];
  seniorities?: EuipoSeniority[];
}
export function searchEuipoTrademarks(params: TrademarkSearchParams): Promise<EuipoTrademarkResult[]> {
  const query = new URLSearchParams();
  const text = (params.trademark || params.applicationNumber || params.registrationNumber || "").trim();
  if (text) query.set("trademark", text); // Backend detects the EUIPO number automatically
  query.set("page", String(params.page ?? 0));
  query.set("size", String(params.size ?? 10));
  if (params.claimType) query.set("claimType", params.claimType);
  if (params.referenceDate) query.set("referenceDate", params.referenceDate);
  if (params.claimType === "seniority" && params.country) query.set("country", params.country);
  return apiFetch(`/api/euipo/trademarks/search?${query.toString()}`);
}
export function getEuipoTrademarkDetails(applicationNumber: string): Promise<EuipoTrademarkDetails> {
  return apiFetch(`/api/euipo/trademarks/${encodeURIComponent(applicationNumber)}`);
}
